<template>
  <section class="rule">
    <img src="https://cdn.gelonghui.com/webActive/img_explain_titlea.png"
         alt />
    <img src="https://cdn.gelonghui.com/webActive/img_explain_formc.png"
         alt />
    <img src="https://cdn.gelonghui.com/webActive/img_explain_contentb.png"
         alt />
    <img src="https://cdn.gelonghui.com/webActive/img_explain_systemb.png"
         alt />
    <img src="https://cdn.gelonghui.com/webActive/img_explain_serviceb.png"
         alt />
    <img src="https://cdn.gelonghui.com/webActive/img_explain_doubta.png"
         alt />
    <p>以上信息的最终解释权归格隆汇所有</p>
    <button @click="beMember">加入会员</button>
  </section>
</template>

<script>
// import axios from "axios"
export default {
  name: "rule",
  data() {
    return {
      val: ""
    };
  },
  created() { },
  mounted() {
    document.title = "格隆汇会员体系介绍";
    window.wechatagain = {
      title: "加入格隆汇会员，发现价值，快人一步",
      content: "格隆汇会员体系介绍",
      image: "https://cdn.gelonghui.com/webActive/wechat-system.png"
    };
  },
  methods: {
    beMember() {
      window.location.href = "https://m.gelonghui.com/user/member";
    }
  }
};
</script>
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
  box-sizing: border-box;
}

.rule {
  position: relative;
  padding-bottom: 100px;
  max-width: 750px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  // background-color: #282C37;
  background: #282c37 url(https://cdn.gelonghui.com/webActive/img_bg.png)
    no-repeat;
  background-size: 100%;

  img {
    width: 100%;
  }

  > p {
    margin-top: 40px;
    font-size: 20px;
    font-weight: 300;
    color: rgba(255, 255, 255, 0.2);
  }

  > button {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 88px;
    border: none;
    outline: none;
    text-align: center;
    background: linear-gradient(
      90deg,
      rgba(255, 224, 170, 1) 0%,
      rgba(255, 224, 170, 1) 100%
    );
    font-size: 30px;
    font-weight: 600;
    color: rgba(120, 72, 47, 1);
    line-height: 88px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/member-share/join.vue